var mobileUtils = {
    showFlashMessage: function (type, message, duration, element) {
        console.warn('mobileUtils.showFlashMessage is deprecated. Please use Alkami.FlashBanner.show instead.');

        type = Object.keys(Alkami.FlashBanner.flashBanner.types).find(function(t) { return t === type.toLowerCase(); }) || 'warning';
        duration = duration || 3000;
        Alkami.FlashBanner.show(message, type, duration, element);
    },

    hideFlashMessage: function () {
        console.warn('mobileUtils.removeFlashMessage is deprecated. Please use Alkami.FlashBanner.hide instead.');
        Alkami.FlashBanner.hide();
    },

    removeFlashMessage: function () {
        console.warn('mobileUtils.removeFlashMessage is deprecated. Please use Alkami.FlashBanner.hide(true); instead.');
        Alkami.FlashBanner.hide(true);
    },

    formatNumber: function(value) {
        console.warn('mobileUtils.formatNumber is deprecated. Please use Alkami.CurrencyHelper.formatCurrency instead.');
        // if it is null, return 0
        if (value == null) {
            return "0.00";
        }

        if (typeof value == "string") {
            value = mobileUtils.unformatMoney(value);
        }

        if (isNaN(value)) {
            return "0.00";
        }

        return value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },

    formatMoney: function(value) {
        console.warn('mobileUtils.formatMoney is deprecated. Please use Alkami.CurrencyHelper.formatCurrency instead.');
        var formattedAmount = mobileUtils.formatNumber(value);
        if (value < 0) {
            return '($' + formattedAmount.replace('-', '') + ')';
        }

        return '$' + formattedAmount;
    },

    unformatMoney: function(value) {
        console.warn('mobileUtils.unformatMoney is deprecated. Please use Alkami.CurrencyHelper.parseCurrency instead.');
        return parseFloat(value.replace(/[^0-9.]/g, ''));
    },

    monthsBetween: function () {
        console.warn('mobileUtils.monthsBetween is deprecated. Please use Alkami.DateHelper.monthsBetween instead.');
        return Alkami.Utils.DateHelper.monthsBetween.apply(this, arguments);
    }
};
